// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-tabs .ant-tabs-ink-bar {
  background-color: #2C3F7E; /* Dark Blue */
}`, "",{"version":3,"sources":["webpack://./src/components/Common/CustomTab/CustomTab.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA,EAAA,cAAA;AACJ","sourcesContent":[".custom-tabs .ant-tabs-ink-bar {\n    background-color: #2C3F7E; /* Dark Blue */\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
